(function () {
  'use strict';

  var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var legacyKeys = ['fulfillment_method', 'fulfillment_zip', 'pickup_location_name', 'pickup_location_id', 'local_delivery_verified', 'fulfillment_confirmed_at'];
  var cleanupStarted = false;

  function addGuidance() {
    var footer = document.querySelector('#rebuy-cart [data-rebuy-cart-anchor="footer"]');
    if (!footer || footer.querySelector('[data-wtpb-checkout-guidance]')) return;
    var section = document.createElement('details');
    section.className = 'wtpb-fulfillment';
    section.setAttribute('data-wtpb-checkout-guidance', '');
    section.setAttribute('aria-labelledby', 'wtpb-checkout-guidance-title');
    var title = document.createElement('summary');
    title.id = 'wtpb-checkout-guidance-title';
    title.className = 'wtpb-fulfillment__title';
    title.textContent = 'Choose delivery or pickup at checkout';
    var detail = document.createElement('p');
    detail.className = 'wtpb-fulfillment__helper';
    detail.textContent = 'For free route pickup, select Pickup in the checkout delivery section, then choose your pickup location. Check the selected store before paying, including in Shop Pay.';
    var link = document.createElement('a');
    link.href = rootPath + 'pages/delivery-routes';
    link.textContent = 'View pickup locations and route dates';
    var rates = document.createElement('p');
    rates.className = 'wtpb-fulfillment__helper';
    rates.textContent = 'Shipping and eligible local delivery rates are shown at checkout.';
    section.appendChild(title);
    section.appendChild(detail);
    section.appendChild(link);
    section.appendChild(rates);
    footer.insertBefore(section, footer.firstChild);
  }

  function clearLegacyPreferences() {
    if (cleanupStarted) return;
    cleanupStarted = true;
    fetch(rootPath + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        var attributes = {};
        legacyKeys.forEach(function (key) {
          if (cart.attributes && cart.attributes[key]) attributes[key] = '';
        });
        if (!Object.keys(attributes).length) return;
        return fetch(rootPath + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart preference cleanup failed');
        });
      })
      .catch(function () { cleanupStarted = false; });
  }

  function init() {
    addGuidance();
    clearLegacyPreferences();
    new MutationObserver(addGuidance).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pageshow', function () {
      addGuidance();
      clearLegacyPreferences();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


(function () {
  'use strict';
  if (window.WTPBCartDetailsReady) return;
  window.WTPBCartDetailsReady = true;
  var queued = false;

  function enhance() {
    queued = false;
    var milestones = document.getElementById('wtx-gift-milestones');
    if (!milestones) return;
    var terms = milestones.querySelector('small');
    if (!terms) return;
    if (!document.getElementById('wtpb-cart-details-style')) {
      var style = document.createElement('style');
      style.id = 'wtpb-cart-details-style';
      style.textContent = '#rebuy-cart .wtpb-gift-summary{display:flex;align-items:center;gap:8px}#rebuy-cart .wtpb-gift-summary__text{flex:1;min-width:0;text-align:left}#rebuy-cart .wtpb-gift-details-toggle{flex:0 0 auto;margin:0;padding:4px 0;border:0!important;background:transparent;box-shadow:none;text-decoration:underline;cursor:pointer}#rebuy-cart [data-wtpb-checkout-guidance] summary{cursor:pointer}';
      document.head.appendChild(style);
    }
    if (terms.id !== 'wtpb-gift-details') terms.id = 'wtpb-gift-details';
    var toggle = milestones.querySelector('.wtpb-gift-details-toggle');
    if (!toggle) {
      var header = document.createElement('div');
      header.className = 'wtpb-gift-summary';
      var summary = document.createElement('span');
      summary.className = 'wtpb-gift-summary__text';
      summary.textContent = 'Your order rewards';
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'wtpb-gift-details-toggle';
      toggle.textContent = 'Gift details';
      toggle.setAttribute('aria-controls', terms.id);
      toggle.addEventListener('click', function () {
        var open = !milestones.classList.contains('wtpb-gift-details-open');
        milestones.classList.toggle('wtpb-gift-details-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
      header.appendChild(summary);
      header.appendChild(toggle);
      milestones.insertBefore(header, milestones.firstChild);
      milestones.classList.add('wtpb-gift-details-ready');
    }
    var expanded = String(milestones.classList.contains('wtpb-gift-details-open'));
    if (toggle.getAttribute('aria-expanded') !== expanded) toggle.setAttribute('aria-expanded', expanded);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(enhance);
  }

  function init() {
    enhance();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
